import React, {Component} from "react";
import {connect} from "react-redux";
import * as podepisujiciActions from "../../actions/podepisujiciActions";
import PropTypes from "prop-types";
import SearchField from "../SearchField";

/**
 * field pro filtrování podepisujících
 */
class QsignPodepisujiciField extends Component {
    static propTypes = {
        empty: PropTypes.bool,
    };
    static defaultProps = {
        empty: true,
    };


    handleFulltextChange = (fulltext) => {
        const {dispatch} = this.props;
        dispatch(podepisujiciActions.setFulltext(fulltext))
    };

  render() {
    return (
        <SearchField
            onChange={(value) => {
                this.handleFulltextChange(value)
            }}
            placeholder={"Zafiltrovat podepisující"}
        />
    );
  }
}

export default connect((state) => {
    return state;
})(QsignPodepisujiciField);
